import React from 'react';
import { HOME_CRAWL_LINKS, OFFERINGS } from '../../../content/enterpriseMessaging';
import SectionSurface from '../shared/SectionSurface';
import {
  CloudIcon,
  UserGroupIcon,
  ChartBarSquareIcon,
  CpuChipIcon,
  PresentationChartBarIcon,
  Squares2X2Icon,
  SparklesIcon,
} from '@heroicons/react/24/outline';

const OFFERING_STYLE = {
  'Semantic HR': {
    Icon: UserGroupIcon,
    accent: 'bg-[rgba(0,18,63,0.08)] text-brand-900 border-[rgba(0,18,63,0.16)]',
  },
  'Interactive Analytics & BI Catalog': {
    Icon: ChartBarSquareIcon,
    accent: 'bg-brand-50 text-brand-600 border-brand-100',
  },
  'Workforce & Operational Intelligence': {
    Icon: PresentationChartBarIcon,
    accent: 'bg-accent-50 text-accent-700 border-accent-100',
  },
  'Snowflake Platforms & Migration (AIM)': {
    Icon: CloudIcon,
    accent: 'bg-accent-50 text-accent-700 border-accent-100',
  },
  'Embedded BI & Dashboard Marketplace': {
    Icon: Squares2X2Icon,
    accent: 'bg-brand-50 text-brand-600 border-brand-100',
  },
  'Semantic Modeling & Domain Memory': {
    Icon: SparklesIcon,
    accent: 'bg-[rgba(0,18,63,0.08)] text-brand-900 border-[rgba(0,18,63,0.16)]',
  },
};

export default function ContentGrid() {
  return (
    <SectionSurface variant="dots" bleed="both" flowTop flowBottom overlap className="section">
      <div className="container-x">
        <div className="mx-auto max-w-2xl text-center">
          <p className="eyebrow">Offerings</p>
          <h2 className="mt-3 text-3xl font-semibold tracking-tight text-ink-900 sm:text-4xl">
            Solutions across your analytics lifecycle.
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-ink-600">
            From migration and platform engineering to semantic layers, interactive BI, and
            AI-powered decision intelligence, mapped to the platforms you already operate.
          </p>
          <nav aria-label="Product pages" className="mt-6 flex flex-wrap items-center justify-center gap-x-5 gap-y-2">
            {HOME_CRAWL_LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="inline-flex min-h-[24px] items-center text-sm font-medium text-brand-600 hover:text-brand-700"
              >
                {link.label}
              </a>
            ))}
          </nav>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {OFFERINGS.map((offering) => {
            const style = OFFERING_STYLE[offering.name] || {
              Icon: CpuChipIcon,
              accent: 'bg-brand-50 text-brand-600 border-brand-100',
            };
            const { Icon, accent } = style;
            return (
              <a
                key={offering.name}
                href={offering.href}
                className="card-hover group flex flex-col border border-ink-200/80 p-6 shadow-sm"
              >
                <span
                  className={`flex h-12 w-12 items-center justify-center rounded-full border ${accent}`}
                >
                  <Icon className="h-6 w-6" aria-hidden="true" />
                </span>
                <h3 className="mt-5 text-base font-semibold text-ink-900">{offering.name}</h3>
                <p className="mt-2 flex-grow text-base leading-relaxed text-ink-600">
                  {offering.summary}
                </p>
                <span className="mt-5 inline-flex items-center text-sm font-medium text-brand-700 group-hover:text-brand-800">
                  Learn more <span className="ml-1">→</span>
                </span>
              </a>
            );
          })}
        </div>
      </div>
    </SectionSurface>
  );
}
